const SimpleChartRenderer = require('./SimpleChartRenderer');
const RenderUtil = require('../RenderUtil');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');

/**
 * 饼图渲染
 * @ignore
 * @inheritdoc
 */
let renderer = SimpleChartRenderer.extend({
    options: {},
    initialize(options) {
        SimpleChartRenderer.prototype.initialize.call(this, options);
        //
    },
    /**
     * @override
     */
    getGvInstance(source) {
        if (this.gvInstance == null) {
            let emptySource = new gv.source.GeoJsonSource(RenderUtil.emptyFeatureCol());
            this.gvInstance = new gv.chart.PieStatisticsChart(source || emptySource, this.getGvOptions());
            this.gvInstance.bind(this.options.map, gv.chart.MapType.TSMap);
            this.addListeners();
        }
        return this.gvInstance;
    }
});

module.exports = renderer;